/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menudishcountone3Inputs */

const en_menudishcountone3 = /** @type {(inputs: Menudishcountone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 dish`)
};

const de_menudishcountone3 = /** @type {(inputs: Menudishcountone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Gericht`)
};

/**
* | output |
* | --- |
* | "1 dish" |
*
* @param {Menudishcountone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menudishcountone3 = /** @type {((inputs?: Menudishcountone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menudishcountone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menudishcountone3(inputs)
	return de_menudishcountone3(inputs)
});
export { menudishcountone3 as "menuDishCountOne" }